<div class="string2-condition-editor" *ngIf="condition" [formGroup]="detailsFormGroup">

    <div class="row">
        <mat-form-field class="flex-grow">
            <input matInput formControlName="string2" name="string2" maxlength="255"
                placeholder="{{'string 2' | translate: ['tmc-yard.entity.transport.masterdata.string2', translationService.language]}}"
                [maxlength]="255">
        </mat-form-field>
    </div>
</div>
